import type { Finding } from "../../domain/types";
import "./FindingsList.css";

export interface FindingsListProps {
  findings: Finding[];
}

const SEVERITY_LABEL: Record<Finding["severity"], string> = {
  info: "Información",
  warning: "Advertencia",
  error: "Error",
  critical: "Crítico",
};

/**
 * Lista de hallazgos. Cada elemento usa <details>/<summary> nativo: expandir/contraer
 * evidencia sin JavaScript de gestos personalizados ni roles ARIA de acordeón.
 * La severidad se comunica con texto además de color (nunca solo color).
 */
export function FindingsList({ findings }: FindingsListProps) {
  if (findings.length === 0) {
    return (
      <p className="findings-list__empty">
        Sin hallazgos: la ejecución no produjo advertencias ni errores de dominio.
      </p>
    );
  }

  return (
    <ul className="findings-list">
      {findings.map((finding) => (
        <li key={`${finding.ruleId}-${finding.message}`} className="findings-list__item">
          <details>
            <summary>
              <span className={`badge badge--${finding.severity}`}>
                {SEVERITY_LABEL[finding.severity]}
              </span>
              <span className="findings-list__message">{finding.message}</span>
            </summary>
            <dl className="findings-list__detail">
              <div>
                <dt>Regla</dt>
                <dd className="mono">{finding.ruleId}</dd>
              </div>
              {finding.evidencePath && (
                <div>
                  <dt>Evidencia</dt>
                  <dd className="mono">{finding.evidencePath}</dd>
                </div>
              )}
              {finding.suggestion && (
                <div>
                  <dt>Sugerencia</dt>
                  <dd>{finding.suggestion}</dd>
                </div>
              )}
            </dl>
          </details>
        </li>
      ))}
    </ul>
  );
}
